<template>
<div class="unit_box">
  <!-- <el-checkbox
    :indeterminate="infoObj.isIndeterminate"
    v-model="infoObj.checked"
    @change="handleCheckUnit">
    {{infoObj.unit}}
  </el-checkbox> -->
  <div class="unit_name">{{infoObj.unit}}</div>
  <div class="elev_list">
    <MonitElevator
      v-for="(elevator, idx) in infoObj.value"
      :key="elevator.deviceGuid + '__' + idx"
      :transport.sync="elevator"
      @check-change="checkChange">
    </MonitElevator>
  </div>
</div>              
</template>

<script>
import ListMixin from './mixin/ListMixin'
import MonitElevator from './MonitElevator'

export default {
  name: 'MonitUnit',
  components: { MonitElevator },
  mixins: [ ListMixin ],
  props: {
    // transport: {
    //   type: Object,
    //   default () {
    //     return {
    //       unit: '',   // 单元名
    //       value: []   // 电梯设备列表
    //     }
    //   }
    // }
  },
  destroyed () {
    this.infoObj = null
  },
  methods: {
    handleCheckUnit (val) {
      console.log('勾选单元:' + this.infoObj.unit, val)
      this.changeItemStatus(this.infoObj, val)
      this.$emit('check-change')
    }
  }
}
</script>

<style lang="scss" scoped>
.unit_box {
  font-size: 12px;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  border-top: 1px solid #E9E9E9;
  &:not(:last-child) {
    margin-bottom: 5px;
  }
  .unit_name {
    width: 80px;
    height: 30px;
    line-height: 30px;
    padding-left: 10px;
    flex-shrink: 0;
  }
  .elev_list {
    flex-grow: 1;
    display: flex;
    justify-content: flex-end;
    flex-wrap: wrap;
    ::v-deep .el-checkbox {
      border-left: 1px solid #E9E9E9;
      border-bottom: 1px solid #E9E9E9;
      border-radius: 0;
      min-width: 90px;
      height: 30px;
      line-height: 30px;
      margin: 0;
      padding: 0 0 0 6px;
      .el-checkbox__label {
        color: #666;
        padding-left: 6px;
      }
    }
  }
  .tip_txt {
    background: #fff;
    border: 1px solid rgba(#282729, 0.6);
    border-radius: 4px;
    box-shadow: 0px 6px 12px 0px rgba(#282729, 0.2);
    color: #282729;
    padding: 6px 10px;
    position: absolute;
    left: -330px;
    top: -36px;
    &.more {
      left: -20px;
    }
    .tip_arrow {
      position: absolute;
      left: 336px;
      bottom: -6px;
      border-color: transparent;
      border-style: solid;
      border-width: 6px;
      border-bottom-width: 0;
      border-top-color: #282729;
      &.more {
        left: 26px;
      }
      &::after {
        content: '';
        position: absolute;
        border-color: transparent;
        border-style: solid;
        border-width: 5px;
        bottom: 1px;
        margin-left: -5px;
        border-top-color: #fff;
        border-bottom-width: 0;
      }
    }
  }
}
</style>
